import { render, staticRenderFns } from "./FloatBtn.vue?vue&type=template&id=09c52bae&scoped=true&"
import script from "./FloatBtn.vue?vue&type=script&lang=js&"
export * from "./FloatBtn.vue?vue&type=script&lang=js&"
import style0 from "./FloatBtn.vue?vue&type=style&index=0&id=09c52bae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c52bae",
  null
  
)

export default component.exports